import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import React from "react";

import { Button } from "../../components/buttons/Button";
import { DlpQuotationOverview } from "../../components/quotationOverview/dlp/DlpQuotationOverview";
import { Step } from "../../components/stepIndicator/Step";
import { StepIndicator } from "../../components/stepIndicator/StepIndicator";
import { useDidMount } from "../../hooks/useDidMount";
import { useDlpFlowContext } from "../../hooks/useDlpContext";
import styles from "./DlpFlowStepFour.module.scss";

interface Props {
  fields: Record<string, Field<string>>;
}

export const DlpFlowStepFour = ({ fields }: Props) => {
  const { data, currentStep, goBack, goToStepFive, premium, dictionary } = useDlpFlowContext();

  const goToStep5 = () => goToStepFive(fields.Step5Path.value);

  useDidMount(() => {
    if (currentStep !== 4) {
      goBack(1, fields.Step2Path.value);
    }
  });

  const handleStepClick = (index: number) => () => {
    if (index === 0) {
      goBack(1, fields.Step1Path.value);
    }

    if (index === 1) {
      goBack(2, fields.Step2Path.value);
    }

    if (index === 2) {
      goBack(3, fields.Step3Path.value);
    }
  };

  if (currentStep !== 4) {
    return null;
  }

  return (
    <>
      <StepIndicator handleClick={handleStepClick} activeStepIndex={3}>
        <Step label={fields.step1Name.value} labelMobile={fields.step1MobileName.value} />
        <Step label={fields.step2Name.value} labelMobile={fields.step2MobileName.value} />
        <Step label={fields.step3Name.value} labelMobile={fields.step3MobileName.value} />
        <Step label={fields.step4Name.value} labelMobile={fields.step4MobileName.value} />
        <Step label={fields.step5Name.value} labelMobile={fields.step5MobileName.value} />
      </StepIndicator>
      <section className={styles.dlpFlowStepFour__wrapper}>
        <DlpQuotationOverview
          insurers={data.insuredPersons}
          crosswiseInsured={data.crosswiseInsured === "Yes"}
          mortgageSupplier={data.mortgageSupplierLabel}
          coverages={data.coverages}
          insuranceTaker={data.insuranceTaker}
          dictionary={dictionary}
          paymentTerm={data.paymentTerm}
          premium={premium}
          showDisclaimer
        />

        <div className={styles.dlpFlowStepFour__buttons}>
          <Button id="button_share" onClick={() => window.print()} type="outlined">
            <Text field={fields.QuotationShareButtonText} />
          </Button>

          <Button
            id="button_submit_quotation"
            leading={<i className={`icon icon-pencil ${styles["dlpFlowStepFour__submit-button-icon"]}`} />}
            onClick={goToStep5}
            type="primary"
          >
            <Text field={fields.QuotationSubmitButtonText}></Text>
          </Button>
        </div>
      </section>
    </>
  );
};
